import ChevronDownSvg from "$assets/icons/chevron-down.svg?icon";
import type { ComponentProps } from "react";

// Defaults to the primary colour (its prior default; also used as MUI Select's
// IconComponent, which passes no colour). Callers can override `color`.
const ChevronDownIcon = (props: ComponentProps<typeof ChevronDownSvg>) => (
  <ChevronDownSvg color="primary" {...props} />
);

export default ChevronDownIcon;
